import * as React from 'react';
import {
    Create,
    TextInput,
    required,
    SimpleForm,
    DateInput,
    SelectInput,
    ReferenceInput,
    minValue,
    useNotify,
    useRedirect,
    NumberInput,
} from 'react-admin';
import { STATUSES } from '../../common/constants';
import FileUpload from '../../common/inputs/FileUpload';
import SlugInput from '../../common/inputs/SlugInput';
import { goApi } from '../../services';
import { apiRoutes } from '../../services/apiRoutes';

const CategoryCreate = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    const handleSubmit = async (values: any) => {
        try {
            await goApi.post(apiRoutes.ECOM_CATEGORIES, values);

            notify('Category created successfully', { type: 'success' });
            redirect('/ecom_categories');
        } catch (error: any) {
            notify(error.message || 'Create failed', { type: 'error' });
        }
    };
    return (
        <SimpleForm onSubmit={handleSubmit}>
            <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
            <TextInput source="name" fullWidth validate={[required()]} />
            <SlugInput source="slug" fullWidth />
            <NumberInput
                type={'number'}
                source="displayOrder"
                fullWidth
                validate={[required(), minValue(0)]}
            />
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                validate={[required()]}
                choices={STATUSES}
            />
        </SimpleForm>
    );
};

export default CategoryCreate;
